import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import {getMessageText} from '../../../utils/messageText';
import {isAgentSystemUserMessage} from '../../../utils/systemChatMessages';
import {parseUserDecisionPresentation} from '../../../utils/userDecisionPresentation';
import ToolPartRenderer from './ToolPartRenderer';
import MessageIntegrations from './MessageIntegrations';
import styles from './styles.module.css';

export default function Message({
  message,
  isStreaming = false,
  messageIntegrations = null,
  isIntegrationOnly = false,
  onIntegrationSideEffect = null,
}) {
  const isUser = message.role === 'user';
  const text = getMessageText(message);
  const systemTextPart = message.parts?.find(
    (part) => part.type === 'text' && isAgentSystemUserMessage(part.text),
  );
  const userDecisionPresentation =
    isUser && systemTextPart
      ? parseUserDecisionPresentation(systemTextPart.text)
      : null;
  const isHiddenSystemUserMessage =
    isUser && systemTextPart && !userDecisionPresentation?.visible;
  const textParts = message.parts?.filter((p) => p.type === 'text') || [];
  const fileParts = message.parts?.filter((p) => p.type === 'file') || [];
  const decisionImageUrls = userDecisionPresentation?.imageUrls || [];
  const toolParts =
    message.parts?.filter((p) => p.type?.startsWith('tool-')) || [];
  const hasMessageIntegrations = Boolean(messageIntegrations?.length);
  const visibleText = textParts.map((part) => part.text).join('').trim();
  const showTextContent =
    !isIntegrationOnly &&
    (visibleText.length > 0 || (!isStreaming && Boolean(text)));
  const showBubble =
    !isIntegrationOnly &&
    (showTextContent ||
      (isUser && fileParts.length > 0) ||
      Boolean(userDecisionPresentation?.visible));

  if (isHiddenSystemUserMessage) {
    return null;
  }

  return (
    <div
      className={`${styles.message} ${
        isUser ? styles.messageUser : styles.messageAssistant
      }`}
    >
      {isUser ? (
        <div className={styles.messageBubbleUser}>
          {(fileParts.length > 0 || decisionImageUrls.length > 0) && (
            <div className={styles.messageFileParts}>
              {fileParts.map((part, index) => (
                <img
                  key={`${part.url}-${index}`}
                  src={part.url}
                  alt={part.filename || 'Imagem anexada'}
                  className={styles.messageFileImage}
                />
              ))}
              {decisionImageUrls.map((url, index) => (
                <img
                  key={`${url}-${index}`}
                  src={url}
                  alt="Imagem da campanha"
                  className={styles.messageFileImage}
                />
              ))}
            </div>
          )}
          {userDecisionPresentation?.visible ? (
            <span>{userDecisionPresentation.defaultText}</span>
          ) : (
            visibleText.length > 0 && <span>{text}</span>
          )}
        </div>
      ) : (
        <div className={styles.messageContent}>
          {showBubble && (
            <div
              className={`${styles.messageBubbleAssistant} ${
                isStreaming ? styles.messageBubbleStreaming : ''
              }`}
            >
              {showTextContent &&
                (textParts.length > 0
                  ? textParts.map((part, i) =>
                    isStreaming ? (
                      <span key={i} className={styles.streamingText}>
                        {part.text}
                      </span>
                    ) : (
                      <ReactMarkdown key={i} remarkPlugins={[remarkGfm]}>
                        {part.text}
                      </ReactMarkdown>
                    ),
                  )
                  : !isStreaming &&
                    text && (
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                      {text}
                    </ReactMarkdown>
                  ))}
              {!isIntegrationOnly &&
                toolParts.map((part, i) => (
                  <ToolPartRenderer key={i} part={part} />
                ))}
            </div>
          )}
          {hasMessageIntegrations && !isStreaming && (
            <div className={styles.messageIntegrations}>
              <MessageIntegrations
                activeIntegrations={messageIntegrations}
                onSideEffect={onIntegrationSideEffect}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
